var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "my-box" },
    [
      _c(
        "el-card",
        { staticClass: "my-card topS", attrs: { shadow: "always" } },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "50px" } },
            [
              _c(
                "el-row",
                {
                  staticStyle: { "margin-bottom": "0" },
                  attrs: { gutter: 10 },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 3 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "品牌" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                filterable: "",
                                placeholder: "请选择",
                              },
                              on: { change: _vm.selectOne },
                              model: {
                                value: _vm.searchForm.brandId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "brandId", $$v)
                                },
                                expression: "searchForm.brandId",
                              },
                            },
                            _vm._l(_vm.brandSelectData, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.brandName,
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 5 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "门店" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                filterable: "",
                                placeholder: "请选择",
                              },
                              model: {
                                value: _vm.searchForm.hotelId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "hotelId", $$v)
                                },
                                expression: "searchForm.hotelId",
                              },
                            },
                            _vm._l(_vm.hotelSelectData, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 3 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "房间号", "label-width": "60px" } },
                        [
                          _c("el-input", {
                            attrs: { clearable: "" },
                            model: {
                              value: _vm.searchForm.roomNumber,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "roomNumber", $$v)
                              },
                              expression: "searchForm.roomNumber",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "时间" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              type: "daterange",
                              "default-time": ["00:00:00", "23:59:59"],
                              placeholder: "选择日期",
                            },
                            model: {
                              value: _vm.searchForm.times,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "times", $$v)
                              },
                              expression: "searchForm.times",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 3 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "工单类型", "label-width": "80px" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                filterable: "",
                                placeholder: "请选择",
                              },
                              model: {
                                value: _vm.searchForm.orderType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "orderType", $$v)
                                },
                                expression: "searchForm.orderType",
                              },
                            },
                            _vm._l(
                              _vm.typeLists.orderTypeList,
                              function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 3 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "工单状态", "label-width": "80px" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                filterable: "",
                                placeholder: "请选择",
                              },
                              model: {
                                value: _vm.searchForm.orderStatus,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "orderStatus", $$v)
                                },
                                expression: "searchForm.orderStatus",
                              },
                            },
                            _vm._l(
                              _vm.typeLists.orderStatusList,
                              function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 3 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "处理人", "label-width": "80px" } },
                        [
                          _c("el-input", {
                            attrs: { clearable: "" },
                            model: {
                              value: _vm.searchForm.employeeName,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "employeeName", $$v)
                              },
                              expression: "searchForm.employeeName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _vm.showAdd
                        ? _c(
                            "el-button",
                            {
                              attrs: { size: "mini", type: "primary" },
                              on: { click: _vm.openpopup },
                            },
                            [_vm._v("添加")]
                          )
                        : _vm._e(),
                      _c("span", { staticStyle: { display: "inline-block" } }),
                    ],
                    1
                  ),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c(
                      "div",
                      { staticClass: "grid-content reset-button" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: { click: _vm.handleSearch },
                          },
                          [_vm._v("查询")]
                        ),
                        _c(
                          "el-button",
                          { attrs: { size: "mini" }, on: { click: _vm.reset } },
                          [_vm._v("重置")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tablist, id: "tab", height: _vm.height },
            },
            _vm._l(_vm.execlTab, function (item, i) {
              return _c("el-table-column", {
                key: i,
                attrs: {
                  width: item.width,
                  prop: item.value,
                  align: item.type == "operation" ? "center" : "",
                  label: item.label,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          item.type == "operation"
                            ? _c(
                                "div",
                                { staticClass: "reset-button" },
                                [
                                  _vm.showtoOther && scope.row.orderStatus < 4
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "primary",
                                            size: "mini",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.assignTask(scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v("分派")]
                                      )
                                    : _vm._e(),
                                  _vm.showrework && scope.row.orderStatus == 4
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "warning",
                                            size: "mini",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.rework(scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v("返工")]
                                      )
                                    : _vm._e(),
                                  _vm.showcheckOrder &&
                                  scope.row.orderStatus == 4
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "success",
                                            size: "mini",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.orderFinish(scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v("验收")]
                                      )
                                    : _vm._e(),
                                  _vm.showDelete
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "danger",
                                            size: "mini",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.del(scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v("删除")]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                          item.solt_TEXT
                            ? _c("div", [
                                _vm._v(
                                  "\n      " +
                                    _vm._s(
                                      _vm.showLabelText(
                                        scope.row[item.value],
                                        _vm.typeLists[item.solt_TEXT]
                                      )
                                    ) +
                                    "\n     "
                                ),
                              ])
                            : _c("div", [
                                _vm._v(
                                  "\n      " +
                                    _vm._s(scope.row[item.value]) +
                                    "\n     "
                                ),
                              ]),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              })
            }),
            1
          ),
          _c(
            "div",
            { staticClass: "page" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "current-page": _vm.pageNum,
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.pageSize,
                  layout: "prev, pager, next, sizes, total, jumper",
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("addView", {
        ref: "add",
        attrs: { brandSelectData: _vm.brandSelectData },
      }),
      _c("assignTaskView", { ref: "assignTaskView" }),
      _c("messageStatus", {
        ref: "msgTip",
        attrs: { typeLists: _vm.typeLists },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }